import { addMessages } from '@hana/i18n';

// Khoá chuỗi chrome; dữ liệu, mã nghiệp vụ không dịch.
addMessages('vi', {
 'qe.1': '+ Phí xử lý',
 'qe.2': 'Khách hàng',
 'qe.3': 'Người nhận',
 'qe.4': 'Dịch vụ (chọn nhiều)',
 'qe.5': 'Loại cont & số lượng',
 'qe.6': 'Mở bảng giá',
 'qe.7': 'Gửi phiếu hỏi giá sang Pricing · hạn 24 giờ làm việc.',
 'qe.8': 'Gửi hỏi giá Pricing',
 'qe.9': 'Hãng',
 'qe.10': 'Tàu · ETD',
 'qe.11': 'Hiệu lực',
 'qe.12': 'Giá bán / cont',
 'qe.13': 'rẻ nhất',
 'qe.14': 'Giá dưới sàn',
 'qe.15': 'Gửi khách cần [SAL-MGR] DAVID duyệt.',
 'qe.16': 'Về giá gợi ý',
 'qe.17': 'Tỷ giá USD',
 'qe.18': 'Thêm phí từ kho',
 'qe.19': 'Mã phí',
 'qe.20': 'Tên phí',
 'qe.21': 'Đơn vị',
 'qe.22': 'Đơn giá',
 'qe.23': 'Tiền tệ',
 'qe.24': 'Thành tiền (₫)',
 'qe.25': 'Biểu giá dịch vụ',
 'qe.26': 'Mã',
 'qe.27': 'Dịch vụ',
 'qe.28': 'Nguồn giá',
 'qe.29': 'Thêm',
 'qe.30': 'Hiệu lực đến',
 'qe.31': 'Thanh toán',
 'qe.32': 'Điều kiện kèm báo giá',
 'qe.33': 'Tiêu đề:',
 'qe.34': 'Giá / cont',
 'qe.35': 'Chấp nhận trên myHANA',
 'qe.36': 'Bản 1 / 1 ▾',
 'qe.37': 'Bản 1',
 'qe.38': '2×40HC · YML · 2 phương án · DAVID 15/Oct/2026 08:40',
 'qe.39': 'Lưu thành bản 2',
 'qe.40': 'Dưới sàn · cần [SAL-MGR] DAVID duyệt',
 'qe.41': 'Gửi khách',
 'qe.42': 'Thử lại',
});
addMessages('en', {
 'qe.1': '+ Handling fee',
 'qe.2': 'Customer',
 'qe.3': 'Recipient',
 'qe.4': 'Services (multi-select)',
 'qe.5': 'Container type & quantity',
 'qe.6': 'Open price list',
 'qe.7': 'Send an inquiry ticket to Pricing · due in 24 working hours.',
 'qe.8': 'Send pricing inquiry',
 'qe.9': 'Carrier',
 'qe.10': 'Vessel · ETD',
 'qe.11': 'Validity',
 'qe.12': 'Sell price / cont',
 'qe.13': 'cheapest',
 'qe.14': 'Below floor price',
 'qe.15': 'Sending to the customer needs [SAL-MGR] DAVID approval.',
 'qe.16': 'Back to suggested price',
 'qe.17': 'USD rate',
 'qe.18': 'Add charge from catalog',
 'qe.19': 'Charge code',
 'qe.20': 'Charge name',
 'qe.21': 'Unit',
 'qe.22': 'Unit price',
 'qe.23': 'Currency',
 'qe.24': 'Amount (₫)',
 'qe.25': 'Service price list',
 'qe.26': 'Code',
 'qe.27': 'Service',
 'qe.28': 'Price source',
 'qe.29': 'Add',
 'qe.30': 'Valid until',
 'qe.31': 'Payment',
 'qe.32': 'Quote terms',
 'qe.33': 'Subject:',
 'qe.34': 'Price / cont',
 'qe.35': 'Accept on myHANA',
 'qe.36': 'Version 1 / 1 ▾',
 'qe.37': 'Version 1',
 'qe.38': '2×40HC · YML · 2 options · DAVID 15/Oct/2026 08:40',
 'qe.39': 'Save as version 2',
 'qe.40': 'Below floor · needs [SAL-MGR] DAVID approval',
 'qe.41': 'Send to customer',
 'qe.42': 'Retry',
});
